import React from "react";
import "./ContactUsForm.css";
import Swal from "sweetalert2";


const ContactUsForm = () => {
  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target; // this will now be the <form>
    const formData = new FormData(form);
    formData.append("access_key", "f333e4b3-a1ed-4165-a06a-0db699456e2d");

    const object = Object.fromEntries(formData.entries());
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: json,
    }).then((res) => res.json());

    if (res.success) {
      Swal.fire({
        title: "Success!",
        text: "Mail Sent successfully",
        icon: "success",
        confirmButtonText: "OK",
      });
      form.reset();
    } else {
      Swal.fire({
        title: "Error!",
        text: "Failed to send message. Please try again later.",
        icon: "error",
      });
    }
  };
  return (
    <div className="contactFormContainer">
      <div className="contactFormHead">
        <h3>Send Inquiry</h3>
        <p>
          Please let us know if you have a question, want to leave a comment, or
          would like further information about our Services.
        </p>
      </div>

      <form action="" onSubmit={handleSubmit}>
        <fieldset>
          <div className="contactFormContent">
            <div className="contactFormItem" id="contentLabel">
              <label htmlFor="name">Tell Us Your Name *</label>
            </div>
            <div className="contactFormItem">
              <input type="text" name="name" placeholder="Name*" required />
            </div>
          </div>
          <div className="contactFormContent">
            <div className="contactFormItem" id="contentLabel">
              <label htmlFor="email">Enter Your Email *</label>
            </div>
            <div className="contactFormItem">
              <input type="email" name="email" placeholder="Email*" required />
            </div>
          </div>
          <div className="contactFormContent">
            <div className="contactFormItem" id="contentLabel">
              <label htmlFor="phone">Enter Your PhoneNo *</label>
            </div>
            <div className="contactFormItem">
              <input type="text" name="phone" placeholder="Phone*" required />
            </div>
          </div>
          <div className="contactFormContent">
            <div className="contactFormItem" id="contentLabel">
              <label htmlFor="subject">Enter Your Subject</label>
            </div>
            <div className="contactFormItem">
              <input
                type="text"
                name="user_subject"
                placeholder="Your Subject"
                required
              />
            </div>
          </div>
          <div className="contactFormContent">
            <div className="contactFormItem" id="contentLabel">
              <label htmlFor="message">Message * </label>
            </div>
            <div className="contactFormItem" id="contactFormTextarea">
              <textarea
                name="message"
                placeholder="Write us a Message"
                required
              ></textarea>
            </div>
          </div>
        </fieldset>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default ContactUsForm;
